<template>
    <div class="wxkf-item-editor">
        <div class="avatar-label">
            <span class="require-icon">*</span> 客服头像
        </div>
        <avatar-selector
            :avatar-root="wpaAvatarRoot"
            :edit-avatar="!!value.origin_url"
            :upload-url="uploadAvatarUrl"
            :value="value.origin_url"
            @input="urlChange"
        />
        <br>
        <div class="avatar-label kf-name">
            <span class="require-icon">*</span>
        </div>
        <v-form
            ref="form"
            :model="form"
            @submit="preventSubmit"
            action="."
            method="GET"
        >
            <v-form-item
                v-model="formErrors.name"
                name="name"
                label="客服名称"
                required="客服名称必填"
            >
                <v-input
                    v-model="form.name"
                    :limit="10"
                    name="name"
                    kind="simple"
                    placeholder="请输入客服名称"
                />
            </v-form-item>
        </v-form>
    </div>
</template>

<script>
import conf from 'src/pages/srv/wpa2/detail/conf.js';
import AvatarSelector from './avatar-selector';

export default {
    name: 'WxkfEditor',
    components: {
        AvatarSelector,
    },
    props: {
        value: {
            name: {
                type: String,
                default: '',
            },
            origin_url: {
                type: String,
                default: '',
            },
            open_kfid: {
                type: String,
                default: '',
            },
        },
    },
    data() {
        return {
            wpaAvatarRoot: window.pageData.staticRoot + conf.wpaAvatarRoot,
            uploadAvatarUrl: conf.uploadAvatarUrl,
            form: { name: this.value.name },
            formErrors: {
                name: '',
            },
            originUrl: this.value.origin_url,
        };
    },
    methods: {
        urlChange(url) {
            this.originUrl = url;
        },
        clear() {
            this.form.name = '';
        },
        validate() {
            return new Promise((resolve, reject) => {
                this.$refs.form.validate().then((valid) => {
                    if (valid.join('').length === 0) {
                        // 校验通过
                        resolve({ name: this.form.name, originUrl: this.originUrl });
                    } else {
                        // 校验失败
                        reject();
                    }
                });
            });
        },
        preventSubmit(e) {
            e.preventDefault();
        },
    },
};
</script>
<style lang="less">
@import '~src/common/common.less';
.wxkf-item-editor {
    .avatar-label {
        font-size: 16px;
    }
    .avatar-list {
        margin-left: 8px;
        height: 52px;
        padding-left: 2px;
    }
    .require-icon {
        color: @AidRed;
    }
    .kf-name {
        position: relative;
        top: 58px;
    }
    .v-form {
        margin-top: 25px;
        margin-bottom: 40px;
        clear: both;
        .v-form-item__input {
            margin-left: 10px;
        }
        .v-input--simple {
            width: 374px;
        }
        .v-form-item__label {
            display: none;
        }
    }
}
</style>
